export const Medias = [
    { type: 'image', url: require('./BlackGalaxy.jpg'), title: 'Black Galaxy' },
    { type: 'image', url: require('./Steelgrey.jpg'), title: 'Steel Grey' },
    { type: 'image', url: require('./Icon-brown.jpg'), title: 'Icon brown' },
    { type: 'image', url: require('./Kuppam-Green.jpeg'), title: 'Kuppam Green' },
    { type: 'image', url: require('./Snow-White.jpg'), title: 'Snow White' },
    { type: 'image', url: require('./Forest-white.jpg'), title: 'Forest White' },
    { type: 'image', url: require('./Vizag-blue.jpeg'), title: 'Vizag Blue' },
    { type: 'image', url: require('./Lavender-Blue.jpg'), title: 'Lavender Blue' },

]